import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import './DocumentosPage.css';

const DocumentosPage = () => {
  return (
    <>
      <Header />
      
      <div className="documentos-container">
        <div className="documentos-content">
          <div className="documentos-left">
            <div className="documentos-logo">
              <img src="/logo/Logo_Sem_Fundo.png" alt="Veridicus Logo" className="logo-img" />
              <h1 className="overlay-title">CRIAÇÃO E GESTÃO DE DOCUMENTOS JURÍDICOS</h1>
            </div>
          </div>
          
          <div className="documentos-right">
            <div className="documentos-description">
              <p className="documentos-intro">
                Organize e acompanhe todos os documentos jurídicos da empresa de forma confiável:
              </p>
              
              <ul className="documentos-services">
                <li>Elaboração de contratos empresariais de todos os tipos;</li>
                <li>Revisão e adequação de documentos jurídicos;</li>
                <li>Petições para processos administrativos;</li>
                <li>Pareceres jurídicos especializados;</li>
                <li>Organização de documentação para due diligence; e</li>
                <li>Assessoria jurídica em operações societárias.</li>
              </ul>
              
              <p>
                A tecnologia da Veridicus automatiza a geração, revisão e armazenamento de contratos, pareceres e petições. Com 
                arquivos centralizados, fluxos inteligentes e histórico completo de alterações, cada documento permanece acessível e 
                atualizado. Relatórios e alertas garantem precisão e conformidade, reduzindo retrabalhos e permitindo que sua equipe 
                acompanhe todas as etapas sem sobrecarga manual.
              </p>
            </div>
            
            <div className="documentos-cta">
              <Link to="/fale-conosco" className="cta-button">
                Entre em contato
              </Link>
            </div>
          </div>
        </div>
        
        <div className="documentos-navigation">
          <Link to="/servicos/alvaras" className="nav-prev">
            ← EMISSÃO DE ALVARÁS E AUTORIZAÇÕES
          </Link>
          <Link to="/servicos/registro-marca" className="nav-next">
            REGISTRO DE MARCA NO INPI →
          </Link>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default DocumentosPage;